'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@src/components/Button/Button';
import { Dropdown } from '@src/components/Dropdown/Dropdown';
import { GeoRedirectionModalContent } from '@src/components/GeoRedirectionModal/GeoRedirectionModalContent';
import { dropdownOptions } from '@src/components/GeoRedirectionModal/dropdownOptions';
import { useGeoRedirectionModalHandlers } from '@src/components/GeoRedirectionModal/useGeoRedirectionModalHandlers';
import { useLocale } from '@src/i18n/LocaleProvider';
import type { CountryCode } from '@src/i18n/locales';
export const GeoRedirectionModal = t0 => {
  const $ = _c(41);
  const {
    userCountryCode
  } = t0;
  const [isOpen, setIsOpen] = useState(true);
  let t1;
  if ($[0] !== userCountryCode) {
    t1 = () => {
      if (dropdownOptions.includes(userCountryCode as CountryCode)) {
        return userCountryCode;
      }
    };
    $[0] = userCountryCode;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedCountryCode, setSelectedCountryCode] = useState(t1);
  const {
    t
  } = useLocale("geo-redirection-modal");
  const {
    t: tc
  } = useLocale("countries");
  let t2;
  if ($[2] !== tc) {
    t2 = dropdownOptions.map(code => ({
      id: code,
      displayName: tc(code),
      name: tc(code)
    }));
    $[2] = tc;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const items = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== selectedCountryCode) {
    t4 = {
      selectedCountryCode,
      onClose: t3
    };
    $[5] = selectedCountryCode;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    onConfirm,
    onCancel,
    isLoading
  } = useGeoRedirectionModalHandlers(t4);
  let t5;
  if ($[7] !== t) {
    t5 = t("title");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("subtitle");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="mb-12 text-body-base lg:mb-8">{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("select-your-country");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = id => {
      setSelectedCountryCode(id);
    };
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== items || $[17] !== selectedCountryCode || $[18] !== t8) {
    t10 = <Dropdown listboxOptionsClassNames="z-1000" placeholder={t8} items={items} selectedId={selectedCountryCode} onItemIdSelected={t9} />;
    $[16] = items;
    $[17] = selectedCountryCode;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("confirm");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== isLoading || $[23] !== onConfirm || $[24] !== t11) {
    t12 = <Button isLoading={isLoading} onClick={onConfirm} size="large">{t11}</Button>;
    $[22] = isLoading;
    $[23] = onConfirm;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t) {
    t13 = t("cancel");
    $[26] = t;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== onCancel || $[29] !== t13) {
    t14 = <Button onClick={onCancel} size="large" variant="secondary">{t13}</Button>;
    $[28] = onCancel;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t14) {
    t15 = <div className="mt-6 flex flex-col gap-2 lg:mt-8 lg:flex-row">{t12}{t14}</div>;
    $[31] = t12;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== isOpen || $[35] !== onCancel || $[36] !== t10 || $[37] !== t15 || $[38] !== t5 || $[39] !== t7) {
    t16 = <GeoRedirectionModalContent isOpen={isOpen} onClose={onCancel} title={t5}>{t7}{t10}{t15}</GeoRedirectionModalContent>;
    $[34] = isOpen;
    $[35] = onCancel;
    $[36] = t10;
    $[37] = t15;
    $[38] = t5;
    $[39] = t7;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};